import type { ReactNode } from 'react'
import type { OperationVariables } from '@apollo/client'

import type { Tag } from './tagging.types'
import { TaggingContext } from './TaggingContexts'
import type { TaggingEntityAdapter } from './taggingEntityAdapter.types'
import { useEntityTagging } from './useEntityTagging'

interface EntityTagsProviderProps<
  TAddData,
  TAddVariables extends OperationVariables,
  TRemoveData,
  TRemoveVariables extends OperationVariables,
> {
  adapter: TaggingEntityAdapter<
    TAddData,
    TAddVariables,
    TRemoveData,
    TRemoveVariables
  >
  children: ReactNode
  entityId: string
  entityTags: Tag[]
  refetch: () => Promise<unknown>
}

export const EntityTagsProvider = <
  TAddData,
  TAddVariables extends OperationVariables,
  TRemoveData,
  TRemoveVariables extends OperationVariables,
>(
  props: EntityTagsProviderProps<
    TAddData,
    TAddVariables,
    TRemoveData,
    TRemoveVariables
  >,
) => {
  const { adapter, children, entityId, entityTags, refetch } = props
  const hook = useEntityTagging({
    adapter,
    entityId,
    entityTags,
    refetch,
  })

  return (
    <TaggingContext.Provider value={hook}>{children}</TaggingContext.Provider>
  )
}
